import classNames from "classnames"
import PropTypes from "prop-types"
import React from "react"

class SearchDropdown extends React.Component {
  constructor(props) {
    super(props)
    this.state = {}
    this.handleListItemClick = this.handleListItemClick.bind(this)
    this.listItem = this.listItem.bind(this)
    this.highlightName = this.highlightName.bind(this)
    this.listResults = this.listResults.bind(this)
  }

  componentDidMount() {
    this.searchWidth = document.querySelector("#marinaSearch").clientWidth
  }

  handleListItemClick(item, index) {
    if (this.props.handleAmplitude) {
      this.props.handleAmplitude(item, index)
    }
    this.props.loadPage(item)
  }

  listItem(item, index) {
    const icon =
      item.kind === "internal" ? "fa-kit fa-ship-store" : "fa-kit fa-location"
    return (
      <div
        className={classNames("search-item", "clearfix", {
          "selected-item": this.props.state.highlightedItemIndex === index,
        })}
        key={index}
        onClick={() => this.handleListItemClick(item, index)}
      >
        <i className={icon} />
        <div className="search-item-name">{this.highlightName(item.name)}</div>
        <div className="search-item-location">{item.description}</div>
      </div>
    )
  }

  highlightName(name) {
    const searchText = this.props.state.typedText.toLowerCase()
    const lowerName = name.toLowerCase()
    const pos = lowerName.indexOf(searchText)

    if (pos !== -1) {
      return (
        <span>
          {name.slice(0, pos)}
          <span className="highlight">
            {name.slice(pos, pos + this.props.state.typedText.length)}
          </span>
          {name.slice(pos + this.props.state.typedText.length)}
        </span>
      )
    } else {
      return name
    }
  }

  listResults() {
    return this.props.state.results.map((result) =>
      this.listItem(result, _.indexOf(this.props.state.results, result))
    )
  }

  render() {
    if (this.props.state.displayDropdown) {
      return (
        <div
          className="search-dropdown-wrapper"
          style={{ width: this.searchWidth }}
        >
          {this.listResults()}
        </div>
      )
    } else {
      return <div />
    }
  }
}

SearchDropdown.propTypes = {
  state: PropTypes.object.isRequired,
  loadPage: PropTypes.func.isRequired,
  handleAmplitude: PropTypes.func,
}

export default SearchDropdown
